var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommandBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0H2.5C1.39543 0 0.5 0.895431 0.5 2V18C0.5 19.1046 1.39543 20 2.5 20H18.5C19.6046 20 20.5 19.1046 20.5 18V2C20.5 0.895431 19.6046 0 18.5 0Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 3.75C15.1427 3.75 15.6991 3.98047 16.1093 4.3907C16.5195 4.80094 16.75 5.35734 16.75 5.9375C16.75 6.51766 16.5195 7.07406 16.1093 7.4843C15.6991 7.89453 15.1427 8.125 14.5625 8.125H12.375V5.9375C12.375 5.35734 12.6055 4.80094 13.0157 4.3907C13.4259 3.98047 13.9823 3.75 14.5625 3.75Z",
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 8.125H6.4375C5.85734 8.125 5.30094 7.89453 4.8907 7.4843C4.48047 7.07406 4.25 6.51766 4.25 5.9375C4.25 5.35734 4.48047 4.80094 4.8907 4.3907C5.30094 3.98047 5.85734 3.75 6.4375 3.75C7.01766 3.75 7.57406 3.98047 7.9843 4.3907C8.39453 4.80094 8.625 5.35734 8.625 5.9375V8.125Z",
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 11.875H14.5625C15.1427 11.875 15.6991 12.1055 16.1093 12.5157C16.5195 12.9259 16.75 13.4823 16.75 14.0625C16.75 14.6427 16.5195 15.1991 16.1093 15.6093C15.6991 16.0195 15.1427 16.25 14.5625 16.25C13.9823 16.25 13.4259 16.0195 13.0157 15.6093C12.6055 15.1991 12.375 14.6427 12.375 14.0625V11.875Z",
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4375 16.25C5.85734 16.25 5.30094 16.0195 4.8907 15.6093C4.48047 15.1991 4.25 14.6427 4.25 14.0625C4.25 13.4823 4.48047 12.9259 4.8907 12.5157C5.30094 12.1055 5.85734 11.875 6.4375 11.875H8.625V14.0625C8.625 14.6427 8.39453 15.1991 7.9843 15.6093C7.57406 16.0195 7.01766 16.25 6.4375 16.25Z",
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 8.125H8.625V11.875H12.375V8.125Z",
    stroke: "#E5E5E5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandBtn);
export default __webpack_public_path__ + "static/media/command-btn.0e7b3632c872bb7ba08a080ee4ebe8ca.svg";
export { ForwardRef as ReactComponent };